module.exports = __webpack_public_path__ + "static/media/query.8f7db90c.png";